<template>
<div class="hris-page">
  <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">System Settings</span>
      <h1 class="hris-page-title">Offense Types Settings</h1>
      <p class="hris-page-subtitle">Manage the offense types used for incident reports and sanctions.</p>
    </div>

    <q-form ref="vForm" @submit="onSubmit">
      <div class="row q-col-gutter-md">
        <div class="col-12 col-md-4">
          <div class="hris-form-section">
            <h3 class="hris-form-section-title">Add Offense Type</h3>
            <div class="hris-form-field q-mb-md">
              <q-input v-model="name" label="Offense Name" outlined dense color="green" :rules="[val => !!val || 'Offense name is required']" class="caps"></q-input>
            </div>
            <div class="q-gutter-sm q-mb-md">
              <q-radio keep-color color="green" v-model="is_active" val="Y" label="Active"></q-radio>
              <q-radio keep-color color="green" v-model="is_active" val="N" label="In-active"></q-radio>
            </div>
            <div class="hris-form-actions" style="padding-top: 0;">
              <q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <div class="hris-panel">
            <h3 class="hris-panel-title">Offense Types List</h3>
            <q-table
              flat
              :data="data"
              :columns="columns"
              row-key="id"
            >
              <template v-slot:body="props">
                <q-tr :props="props" @click="selectedRow(props)" style="cursor: pointer;">
                  <q-td key="id" :props="props">{{ props.row.counter }}</q-td>
                  <q-td key="name" :props="props">{{ props.row.name }}</q-td>
                  <q-td key="is_active" :props="props">
                    <span class="hris-badge" :class="props.row.is_active == 'Y' ? 'hris-badge-success' : 'hris-badge-danger'">
                      {{ props.row.is_active == 'Y' ? 'Active' : 'Inactive' }}
                    </span>
                  </q-td>
                  <q-td key="action" :props="props">
                    <q-btn flat round dense class="hris-q-ghost" @click="removeRow(props)">
                      <i class="fas fa-trash"></i>
                      <q-tooltip>Remove</q-tooltip>
                    </q-btn>
                  </q-td>
                </q-tr>
              </template>
              <template v-slot:no-data="">
                <div class="hris-empty full-width">No results found.</div>
              </template>
            </q-table>
          </div>
        </div>
      </div>
    </q-form>
  </div>
</div>
</template>

<script>
import axios from "axios";
import mixins from "../../mixins";

export default {
	mixins: [mixins],
	data() {
		return {
			tempID: 0,
			name: "",
			is_active: "Y",
			data: [],
			columns: [
				{ name: 'id', align: 'left', label: 'ID', field: 'counter' },
				{ name: 'name', align: 'left', label: 'Name', field: 'name' },
				{ name: 'is_active', align: 'left', label: 'Status', field: 'is_active' },
				{ name: 'action', align: 'left', label: 'Action', field: 'action' },
			],
		}
	},
	created() {
		this.getData();
	},
	methods: {
		getData() {
			axios.create({
				headers: { 'Authorization': `Bearer ${this.token}` }
			}).get(this.apiUrl + '/admin/setting/offense')
			.then((res) => {
				this.data = res.data.data;
			})
		},
		onSubmit() {
			let fd = new FormData();
			fd.append("tempID", this.tempID);
			fd.append("name", this.name);
			fd.append("type", "offense");
			fd.append("status", this.is_active);
			fd.append("dept_id", 0);

			axios.create({
				headers: { 'Authorization': `Bearer ${this.token}` }
			}).post(this.apiUrl + '/admin/setting/relationship', fd)
			.then((res) => {
				this.getData();
				this.tempID = 0;
				this.name = "";
				this.is_active = "Y";
				this.$q.notify({
					color: 'positive',
					message: 'Saved successfully',
					icon: 'fas fa-check'
				})
			})
		},
		selectedRow(props) {
			this.tempID = props.row.id;
			this.name = props.row.name;
			this.is_active = props.row.is_active;
		},
		removeRow(props) {
			let fd = new FormData();
			fd.append("tempID", props.row.id);
			axios.create({
				headers: { 'Authorization': `Bearer ${this.token}` }
			}).post(this.apiUrl + '/admin/setting/delete', fd)
			.then((res) => {
				this.getData();
				this.$q.notify({
					color: 'negative',
					message: 'Removed successfully',
					icon: 'fas fa-trash'
				})
			})
		}
	}
}
</script>
